import React, { forwardRef } from 'react';
import { Input } from 'antd';

import { phoneValidator } from '../../../../../Offices/utils/validators';
import {
  innFieldValidator,
  numFieldValidator,
  maxFieldError,
  numFieldError,
  kppFieldValidator,
} from '../../utils/validators';
import { fieldTypes } from '../../constants';

const MAX_FIELD_LENGTH = 500;

// для отображения неизвестных типов полей
export const unknownFieldOptions = Object.freeze({
  decoratorOptions: {
    rules: [
      {
        max: MAX_FIELD_LENGTH,
        message: maxFieldError(MAX_FIELD_LENGTH),
      },
    ],
  },
  render: forwardRef(({ readOnly, isSaving, ...props }, ref) => (
    <Input
      style={{ width: '100%' }}
      ref={ref}
      {...props}
      disabled={true}
    />
  )),
});

export const fieldOptionsMap = Object.freeze({
  [fieldTypes.director]: {
    decoratorOptions: {
      // // пример решения на случай, если будут проблемы с производительностью
      // // https://github.com/ant-design/ant-design/issues/13063#issuecomment-456069046
      // trigger: 'onBlur',
      // valuePropName: 'defaultValue',
    },
    render: forwardRef(({ readOnly, isSaving, ...props }, ref) => (
      <Input
        ref={ref}
        {...props}
        disabled={readOnly || isSaving}
      />
    )),
  },
  [fieldTypes.address]: {
    decoratorOptions: {
      rules: [
        {
          max: MAX_FIELD_LENGTH,
          message: maxFieldError(MAX_FIELD_LENGTH),
        },
      ],
    },
    render: forwardRef(({ readOnly, isSaving, ...props }, ref) => (
      <Input.TextArea
        autoSize={{ minRows: 1 }}
        ref={ref}
        {...props}
        disabled={readOnly || isSaving}
      />
    )),
  },
  [fieldTypes.phone]: {
    decoratorOptions: {
      rules: [
        {
          validator: phoneValidator,
        },
      ],
    },
    render: forwardRef(({ readOnly, isSaving, ...props }, ref) => (
      <Input
        ref={ref}
        {...props}
        disabled={readOnly || isSaving}
      />
    )),
  },
  [fieldTypes.email]: {
    decoratorOptions: {
      rules: [
        {
          type: 'email',
          message:
            'Поле должно содеражить корректную эл.почту. Например, example@example.com',
        },
      ],
    },
    render: forwardRef(({ readOnly, isSaving, ...props }, ref) => {
      return (
        <Input
          ref={ref}
          {...props}
          disabled={readOnly || isSaving}
        />
      );
    }),
  },
  [fieldTypes.inn]: {
    decoratorOptions: {
      rules: [
        {
          validator: numFieldValidator,
          message: numFieldError,
        },
        {
          validator: innFieldValidator,
        },
      ],
    },
    render: forwardRef(({ readOnly, isSaving, ...props }, ref) => (
      <Input
        style={{ width: '100%' }}
        ref={ref}
        {...props}
        disabled={readOnly || isSaving}
      />
    )),
  },
  [fieldTypes.site]: {
    decoratorOptions: {
      rules: [
        {
          type: 'url',
          message:
            'Поле должно содеражить корректную ссылку. Например, https://example.com',
        },
      ],
    },
    render: forwardRef(({ readOnly, isSaving, ...props }, ref) => (
      <Input
        ref={ref}
        {...props}
        disabled={readOnly || isSaving}
      />
    )),
  },
  [fieldTypes.schedule]: {
    decoratorOptions: {
      rules: [
        {
          max: MAX_FIELD_LENGTH,
          message: maxFieldError(MAX_FIELD_LENGTH),
        },
      ],
    },
    render: forwardRef(({ readOnly, isSaving, ...props }, ref) => (
      <Input.TextArea
        autoSize={{ minRows: 1 }}
        ref={ref}
        {...props}
        disabled={readOnly || isSaving}
      />
    )),
  },
  [fieldTypes.information]: {
    decoratorOptions: {
      rules: [
        {
          max: MAX_FIELD_LENGTH,
          message: maxFieldError(MAX_FIELD_LENGTH),
        },
      ],
    },
    render: forwardRef(({ readOnly, isSaving, ...props }, ref) => (
      <Input.TextArea
        autoSize={{ minRows: 1 }}
        ref={ref}
        {...props}
        disabled={readOnly || isSaving}
      />
    )),
  },
  [fieldTypes.specialization]: {
    decoratorOptions: {
      rules: [
        {
          max: MAX_FIELD_LENGTH,
          message: maxFieldError(MAX_FIELD_LENGTH),
        },
      ],
    },
    render: forwardRef(({ readOnly, isSaving, ...props }, ref) => (
      <Input.TextArea
        autoSize={{ minRows: 1 }}
        ref={ref}
        {...props}
        disabled={readOnly || isSaving}
      />
    )),
  },
  [fieldTypes.kpp]: {
    decoratorOptions: {
      rules: [
        {
          validator: numFieldValidator,
          message: numFieldError,
        },
        {
          validator: kppFieldValidator,
        },
      ],
    },
    render: forwardRef(({ readOnly, isSaving, ...props }, ref) => (
      <Input
        style={{ width: '100%' }}
        ref={ref}
        {...props}
        disabled={readOnly || isSaving}
      />
    )),
  },
});
